import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './styles/tokens.css'
import './theme' // 主题色持久化恢复 (副作用: 启动时应用上次选择的 html[data-theme])
import './i18n' // 语言持久化恢复 + 启动时同步 html lang

createApp(App).use(router).mount('#app')
